<template>
  <div class="order-quantity">
    <label>{{ $t('trade.quantity') }}</label>
    <PlusMinusInput
      :step="step"
      :value="value"
      :min="step"
      @input="$emit('input', $event)"
    />
  </div>
</template>
<script>
import PlusMinusInput from 'com/PlusMinusInput'
export default {
  name: 'QuantityInput',
  components: { PlusMinusInput },
  props: {
    step: Number,
    value: [String, Number]
  }
}
</script>
<style lang="less" scoped>
.order-quantity {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 10px 0;
}
</style>
